<!-- TODO: Multilang -->

<!--
-->

<template>
  <v-container fluid>
    <v-row dense class="d-flex " style="height: 50px">
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="open_add({})"
          :disabled="!isAdmin"
        >
        <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
      </v-col>
      <!-- View Title -->
      <v-col >
        <ViewTitle title="Directories" />
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <div>
      <v-data-table
        v-model="table_select"
        :headers="headers"
        :items="items"
        :search="search"
        item-class="qmkey-item-row"
        single-select
        must-sort
        sort-by="readable_path"
        fixed
        small
        dense
        @item-selected="select_directory"
        @click:row="select_directory"
      >
        <template v-slot:item.color="{item}">
          <v-icon :color="item.color">
            mdi-folder
          </v-icon>
        </template>
        <template v-slot:item.name="{item}">
          <span>{{ item.name }}</span>
        </template>
        <template v-slot:item.readable_path="{item}" style="">
          <span
            v-if="(item.readable_path+item.name).length <= 60"
          >
            <span>{{ path_without_current_item(item.readable_path) }}</span>
          </span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                style="cursor:default;"
              >
              <span>{{ path_without_current_item(item.readable_path).substring(0, 60) + "..." }}</span>
              </span>
            </template>
            <span>{{ path_without_current_item(item.readable_path) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-btn icon @click="open_add(item)" :disabled="!can_create">
              <v-icon>mdi-folder-plus-outline</v-icon>
            </v-btn>
  
            <v-btn icon @click="open_edit(item)" :disabled="!can_create">
              <v-icon>
                mdi-folder-settings-outline
              </v-icon>
            </v-btn>
            <v-btn icon @click="delete_folder_form(item)" :disabled="!business_process || (!isAdmin && !isManager) || has_children(item)">
              <v-icon>
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    
      <v-dialog
        v-model="dialog.show"
        max-width="600px"
        @keydown.esc="close"
      >
        <v-card>
          <v-card-title class="modal-card-title">
            <span class="qmkey-modal-h1 pb-0">
              {{ dialog.title }}
            </span>
            <v-spacer></v-spacer>
            
            <v-btn
              class="qmkey-modal-dialog-close"
              text
              plain
              right
              small
              :ripple="false"
              @click="dialog.show = false"
            >
              <v-icon :ripple="false" small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row dense>
                <v-col cols="12">
                  <ExplorerDirectoryPath
                    :path="(selected || {}).path"
                  ></ExplorerDirectoryPath>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="dialog.name"
                    :label="$vuetify.lang.translator('directory.directory_name')"
                    outlined
                    dense
                    background-color="#f2f2f2"
                    class="qmkey-form-input required"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-select
                    v-if="!parent_hidden"
                    v-model="dialog.parent_id"
                    :items="select_directories"
                    :label="$vuetify.lang.translator('directory.father')"
                    :placeholder="$vuetify.lang.translator('directory.select_father')"
                    item-text="name"
                    item-value="id"
                    class="qmkey-form-input"
                    outlined
                    dense
                    background-color="#f2f2f2"
                    clearable
                  >
                    <template>
                      <v-icon slot="append" color="primary">
                        {{ false || 'mdi-menu-down' }}
                      </v-icon>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col
                  align="center"
                  justify="center"
                >
                  <v-color-picker
                    v-model="dialog.color"
                    mode="hexa"
                    :swatches="swatches"
                    show-swatches
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="qmkey-modal-dialog-card-actions">
            <v-spacer></v-spacer>
            <v-btn
              class="qmkey-modal-dialog-button-secundary"
              text
              @click="dialog.show = false"
            >
            {{ $vuetify.lang.translator('dialog.cancel') }}
            </v-btn>
            <v-btn
              class="qmkey-modal-dialog-button-submit"
              text
              @click="dialog.save"
              :disabled="!valid"
            >
            {{ $vuetify.lang.translator('dialog.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <modal-dialog-form
        :title="modal_title"
        :showModalDialog="showModalDialog"
        :fields_to_collect="fields_to_collect"
        :submit_button_text="submit_button_caption"
        validate
        @close-dialog="toggle_dialog"
        @submit="submit_action"
        :message="message"
      >
      </modal-dialog-form>
    </div>
  </v-container>
</template>
    
    
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import '@/sass/modalform.scss';
    
  .explorerdirectory-cont {
    @extend .documentation-table-cont-base;
  }
    
  .explorerdirectory-header {
    @extend .documentation-table-header-base;
    display: flex;
    align-items: center;
  }
</style>
  
  
<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import QDirectory from '@/api/QDirectory';
  import ExplorerDirectoryPath from '@/components/explorer/ExplorerDirectoryPath';
  import SearchTextTable from '@/components/SearchTextTable';
  import ModalDialogForm from '@/components/explorer/ModalDialog';
  import QTree from '@/utils/QTree'
    
  import ViewTitle from '@/components/ViewTitle'
  import SearchTextAdmin from '@/components/header/SearchTextAdmin'
    
    
  export default {
    name: 'Directories',
    
    components: {
      ExplorerDirectoryPath,
      SearchTextTable,
      ModalDialogForm,
      ViewTitle,
      SearchTextAdmin,
    },
      
    props: {
      filters: {},
    },
    
    data: () => ({
      rename_dialog: false,
      dialog: {
        show: false,
        name: '',
        color: '',
        parent_id: '',
        save: function () {},
      },
      search: null,
      directory_colors: [
        '#29a1c5',
        '#404040',
        '#753c8f',
        '#85a43c',
        '#acacac',
        '#ff0000',
        '#f7a42f',
        '#181cbb',
        '#ff66ff',
        '#ffff33',
      ],
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      parent_hidden: false,
      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: '',
      submit_action: function () { },
      message:"",
      
      table_select: [],
      selected: null,
      show_dialog: false,
      business_process: null,// Admin view do not have BP
    }),
    
    computed: {
      ...mapGetters([
        'centro_id',
        'isManager',
        'isAdmin',
      ]),
    
      ...mapState([
        'qdirectory',
        'qdirectory_list',
      ]),
    
      valid() {
        return !!this.dialog.name
      },
    
      select_directories() {
        let dirs = this.qdirectory
        if (dirs) {
          return Object.values(dirs).filter((d) => d.id != (this.selected || {}).id && !this.is_son_of_dir(d))
        }
        return []
      },
    
      can_create() {
        return this.isAdmin || this.isManager;
      },
    
      total_folders_count() {
        return Object.keys(this.qdirectory).length;
      },
  
      items_tree() {
        let v = new QTree(Object.values({...this.qdirectory}))
        //v.fromTree(this.qdirectory_list)
        return v;
      },
      items() {
        //return this.items_tree.plain_tree()
        return Object.values(this.qdirectory)
                  .map(it => ({...it,
                                readable_path: this.full_dir_path(it), 
                                level: it.path.length + 1, 
                                parent_name: this.parent_name(it)}))
      },

      headers() {
        return [
          {
            text: '',
            align: 'start',
            sortable: false,
            filterable: false,
            value: 'color',
          },
          {
            text: 'Id',
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'id',
          },
          {
            text: this.$vuetify.lang.translator('directory.directory_name'),
            align: 'start',
            sortable: true,
            value: 'name',
          },{
            text: this.$vuetify.lang.translator('directory.level'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'level',
          },{
            text: this.$vuetify.lang.translator('directory.father'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'parent_name',
          },{
            text: this.$vuetify.lang.translator('directory.route'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'readable_path',
          },{
            text: '',
            align: 'start',
            sortable: false,
            filterable: false,
            value: 'actions',
          },
        ]
      },
    },
    
    mounted() {
    },
    
    methods: {
      ...mapActions(['LOAD_DIRECTORY_ITEMS']),
      close_dialog() {
        this.show_dialog = false;
      },
      select_directory(a) {
        console.log(a)
        this.selected = (this.selected === a) ? null : a ;
        this.table_select = this.selected ? [this.selected]: [];
      },
      has_children(item) {
        return item.children && item.children.length > 0;
      },
      parent_name(item) {
        return this.dir_name(item.parent_id);        
      },
      dir_name(id) {
        return (Object.values(this.qdirectory).find((it) => it.id == id ) || {}).name;
      },
      dir_path(item) {
        let path = (item.path.filter(it => it.id != item.id) || []);
        if (path.length <= 0) {
          return '';
        }
        return path.map(it => this.dir_name(it)).join('/');
      },
      full_dir_path(item) {
        const path = this.dir_path(item);
        let res = path;
        if (path.length > 0) {
          res = res + '/';
        }
        res = res + item.name;
        return res;
      },
  
      path_without_current_item(path) {
        let a = path.split('/');
        a.pop();
        if (a.length > 0) {
          return "/" + a.join('/') + "/";
        }
        return "";
      },
  
      is_son_of_dir(dir) {
        const item_selected = this.selected ? [this.selected] : [];
        const parent_and_sons = new QTree(item_selected).plain_tree();
        return !!parent_and_sons.find(itm => itm.id == dir.id);
      },
    
      open_add(dir) {
          
        if (dir.id) {
          this.dialog.title = this.$vuetify.lang.translator('directory.add_subdirectory').toUpperCase() + ' ' + dir.name;
          this.dialog.color = dir.color;
          this.dialog.parent_id = dir.id;
        } else {
          this.dialog.title = this.$vuetify.lang.translator('directory.add_directory').toUpperCase();
          this.dialog.color = this.directory_colors[0];
          this.dialog.parent_id = '';
        }
        this.parent_hidden = true;
        this.dialog.show = true;
        this.dialog.name = '';
  
        this.dialog.save = function () {
          this.apply_add_folder();
          this.dialog.show = false;
        }.bind(this)
      },
    
      open_edit(directory) {
        if (!directory.id) {
          return; // No selected directory
        }
        let dir = directory;
        this.dialog.show = true;
        this.dialog.title = this.$vuetify.lang.translator('directory.edit_directory').toUpperCase()
        this.dialog.name = dir.name;
        this.dialog.color = dir.color;
        let parent = Object.values(this.qdirectory).filter(
          (d) => d.id == directory.parent_id,
        );
        this.dialog.parent_id = '';
        if (parent.length > 0) {
          this.dialog.parent_id = parent[0].id;
        }
        this.parent_hidden = false;
        this.dialog.save = (
          function () {
            this.apply_edit_folder();
            this.dialog.show = false;
          }.bind(this)
        );
      },
    
      apply_add_folder() {
        QDirectory.post(this.centro_id, {
          name: this.dialog.name,
          color: this.dialog.color,
          parent: (this.selected || {}).id,
        })
          .then(() => this.update_directories())
          .catch(console.warn)
      },

      apply_edit_folder() {
        QDirectory.put(this.centro_id, this.selected.id, {
          name: this.dialog.name,
          color: this.dialog.color,
          parent: this.dialog.parent_id || null,
        })
          .then(() =>{ 
            this.update_directories();
          })
          .catch(console.warn);
      },
    
      setSearchText(search_text) {
        this.search = search_text;
      },

      // Admin view do not have BP, so delete is not aviable
      delete_folder_form(directory) {
        return;  
        this.modal_title = this.$vuetify.lang.translator('directory.delete_directory')+` #${directory.id}-${directory.name} `;
        this.showModalDialog = true;
        this.fields_to_collect = [];
        this.submit_action = this.delete_folder;
        this.submit_button_caption = this.$vuetify.lang.translator('dialog.delete');
          
      },
      delete_folder() {
        QDirectory.delete(this.centro_id, this.selected.id, this.business_process)
          .then(() => {
            this.update_directories();
            this.toggle_dialog();
          })
          .catch((err) => {
            console.error(err.response.data);
            // this.message = err.response.data
            this.message = this.$vuetify.lang.translator('directory.not_able_to_delete');
          })
      },
  
      update_directories () {
        this.LOAD_DIRECTORY_ITEMS(this.centro_id);
      },
    
      toggle_dialog() {
        this.showModalDialog = false;
        this.modal_title = ``;
        this.fields_to_collect = [];
        this.submit_action = (()=>{});
        this.submit_button_caption = '';
        this.message = "";
      },
    },
    
    watch: {
      enable_button: function () {
        this.valid = this.dialog.name ? true : false;
      },
    },
  };
</script>
